import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  deal: (dealId: string) => getUrlForEnv(services.DEALS_SERVICE, `/v1/deals/${dealId}`),
  deals: () => getUrlForEnv(services.DEALS_SERVICE, "/v1/deals"),
  dealLocales: () => getUrlForEnv(services.DEALS_SERVICE, "/v1/locales"),
  dealFavourites: () => getUrlForEnv(services.DEALS_SERVICE, "/v1/deals/favourites"),
  dealFavouritesForUser: (userId: string) => getUrlForEnv(services.DEALS_SERVICE, `/v1/deals/favourites/${userId}`),

  redemption: (redemptionId: string) => getUrlForEnv(services.DEALS_SERVICE, `/v1/redemptions/${redemptionId}`),
  redemptions: () => getUrlForEnv(services.DEALS_SERVICE, "/v1/redemptions"),

  product: (productId: string) => getUrlForEnv(services.PRODUCTS_SERVICE, `/v1/products/${productId}`),
  products: () => getUrlForEnv(services.PRODUCTS_SERVICE, "/v1/products"),

  stock: (stockId: string) => getUrlForEnv(services.STOCK_SERVICE, `/v1/items/${stockId}`),
  stocks: () => getUrlForEnv(services.STOCK_SERVICE, "/v1/items"),

  settings: (tenantId: string) => getUrlForEnv(services.DEALS_SERVICE, `/v1/settings/${tenantId}`),

  tag: (tagId: string) => getUrlForEnv(services.DEALS_SERVICE, `/v1/tags/${tagId}`),
  tags: () => getUrlForEnv(services.DEALS_SERVICE, "/v1/tags"),

  category: (categoryId: string) => getUrlForEnv(services.DEALS_SERVICE, `/v1/categories/${categoryId}`),
  categories: () => getUrlForEnv(services.DEALS_SERVICE, "/v1/categories")
}

export default endpoints
